<!-- Ruta: http://localhost:4200/#/home/cartera/etiquetas/gestionar -->

<form class="card" [formGroup]="form">
  <div class="card-header">
    Etiquetas de No Gestión (NOG)
  </div>
  <div class="card-body">
    <button type="button" mat-button class="secondary w-100 mb-3" (click)="inputFile.click()">
      Seleccionar archivo
    </button>
    <input type="file" accept=".csv" (change)="onSelectFile(inputFile)" #inputFile hidden>
    <mat-form-field appearance="fill" class="w-100">
      <mat-label>Acción</mat-label>
      <mat-select formControlName="option">
        <mat-option [value]="1">Activar</mat-option>
        <mat-option [value]="0">Desactivar</mat-option>
      </mat-select>
    </mat-form-field>
    <button mat-button class="primary w-100" (click)="submit()"
      [disabled]="!isFileLoaded || !([0,1].includes(this.form.get('option')?.value))">
      {{isFileLoaded? ( this.form.get("option")?.value == 1? "Activar":"Desactivar" )
      + " etiquetas":"Cargue el archivo para continuar"}}
    </button>
    <!-- <button mat-button class="warning w-100 mt-3" (click)="reenviarEtiquetas()" [disabled]="!isResend" *ngIf="isResend">
      Reenviar
    </button> -->
  </div>
</form>
<div class="card mt-3">
  <div class="card-header">
    <strong>Indicaciones</strong>
  </div>
  <div class="card-body">
    <p>
      El archivo cargado debe estar en formato csv, separado por punto y coma <strong>( ; )</strong>.
      <br>
      El archivo debe tener el siguiente formato para ser enviado:
    </p>
    <table class="table table-bordered table-hover table-responsive" width="100%">
      <thead>
        <tr>
          <th>
            <h3>C_AGR</h3>
          </th>
          <th>
            <h3>T_CRE</h3>
          </th>
          <th>
            <h3>CUE</h3>
          </th>
          <th>
            <h3>N_IDE</h3>
          </th>
          <th>
            <h3>ORIGEN</h3>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td colspan="5">{{parsedInfo.length}} registros cargados.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<coky-table class="mt-3" [title]="'Registros cargados: '+parsedInfo.length" [data]="parsedInfo">
</coky-table>
<coky-table class="mt-3" [title]="'Registros incorrectos: '+incorrectInfo.length" [data]="incorrectInfo">
</coky-table>